export default __webpack_public_path__ + "static/media/sendspark-logo.78d44112.svg";